import { render, staticRenderFns } from "./EntityContentView.vue?vue&type=template&id=9bcf50ae&scoped=true"
import script from "./EntityContentView.vue?vue&type=script&lang=js"
export * from "./EntityContentView.vue?vue&type=script&lang=js"
import style0 from "./EntityContentView.vue?vue&type=style&index=0&id=9bcf50ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcf50ae",
  null
  
)

export default component.exports